module.exports = __webpack_public_path__ + "static/media/cola.a5b4a2c3.jpg";